<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmModel = false"
              >Disagree</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >
              Agree
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="formSchema.record_id"
                      label="Module "
                      :rules="[(v) => !!v || 'Field is required']"
                      item-text="menu_name"
                      item-value="id"
                      :items="subMenuList"
                      
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Document Name"
                      v-model="formSchema.document_name"
                      :rules="[(v) => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <label for="">Upload Document</label>
                    <input type="file" id="doc" @change="getImage" />
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <!-- <div class="image-preview" v-if="formSchema.document.length > 0">
											<img class="preview" :src="doc_preview">
										</div> -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" @click.native="reset"><v-icon>refresh</v-icon> Reset</v-btn>
              <v-btn color="success" @click.native="validateBeforeSubmit"><v-icon>save</v-icon>{{
                buttonTitle
              }}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
    <v-container> </v-container>
  </div>
</template>

<script>
let commonService = require("../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    confirmModel: false,
    roleList: [],
    subMenuList: [],
    doc_preview: require("../../assets/logo.png"),
    search: "",
    headers: [
      {
        text: "Sl#",
        align: "left",
        sortable: false,
        value: "id",
      },
      {
        text: "Document Title",
        align: "left",
        sortable: false,
        value: "document_name",
      },
      { text: "Actions", value: "" },
    ],
    items: [],
    message: "",
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Update Document" : "Upload Document";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    },

    document() {
      console.log("change");
    },
  },

  created() {
    let root = this;
    commonService.getAllData("get_submenus").then((res) => {
      root.subMenuList = res.data;
    });
  },

  methods: {
    getAllDocuments() {
      commonService.getAllData("get_all_documents").then((res) => {
        this.items = res.data;
        console.log(this.items)
      });
    },
    setRecordID(e) {
      let obj = this.subMenuList.find((o) => o.id === e);
      this.formSchema.record_id = obj.id;
    },
    getImage(e) {
      let fileInput = e.target;
      if (fileInput.files && fileInput.files[0]) {
        let file = new FileReader();
        file.onload = (e) => {
          this.formSchema.document_file_name = e.target.result;
        };
        file.readAsDataURL(fileInput.files[0]);
      }
    },
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;

      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "document-update")
            .then((res) => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status,
			  };
        document.getElementById('doc').value= null;
			  
              this.close(actionData);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "document-store")
            .then((res) => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status,
			  };
        document.getElementById('doc').value= null;
			  
              this.close(actionData);
            });
        }
      }
    },
    editItem(item) {
      this.formSchema = item;
      this.showForm = true;
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth",
      });
    },
    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "document-delete").then((res) => {
        this.items.splice(row_index, 1);

        this.confirmModel = false;
        // this.reloadData()
      });
    },

    close: function(message) {
      if (message.status == 1) {
		this.$refs.form.reset();
      }
      this.$emit("reloadData", message);
    },
    reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
        document.getElementById('doc').value= null;
      }
    },
  },

  /*mounted() {
    commonService.getAllData("get_submenus").then((res) => {
      this.subMenuList = res.data;
      // console.log(this.subMenuList)
    });
    this.getAllDocuments();
  },*/
};
</script>
<style scoped>
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 20px;
}
img.preview {
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/document_management/upload_document_form.vue